"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const AnnotationMark = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M10.945 15.424l-3.411.602-1.117 1.117a1.403 1.403 0 0 1-.86.357H2.823c-.555 0-.687-.319-.295-.71l2.884-2.885.605-3.425 4.928 4.944zm-3.87-6.008l5.217-5.21c.391-.39 1.164-.706 1.703-.706h8.01c.55 0 .557.434.278.71L12.02 14.378 7.075 9.416zM2.252 19h15.496a.75.75 0 1 1 0 1.5H2.252a.75.75 0 1 1 0-1.5z", children: " " })
] });
var AnnotationMark_default = AnnotationMark;
export {
  AnnotationMark_default as default
};
